import { axios } from "./axios";
export function postAction(url, parameter) {
  return axios({
    url: url,
    method: "post",
    data: parameter,
    dataType: "json",
  });
}

//post method= {post | put}
export function httpAction(url, parameter, method) {
  return axios({
    url: url,
    method: method,
    data: parameter,
  });
}

//put
export function putAction(url, parameter) {
  return axios({
    url: url,
    method: "put",
    data: parameter,
  });
}

//get
export function getAction(url, parameter) {
  return axios({
    url: url,
    method: "get",
    params: parameter,
  });
}

//deleteAction
export function deleteAction(url, parameter) {
  return axios({
    url: url,
    method: "delete",
    params: parameter,
  });
}

// 我的-我的消息
export function RegistApp(url, parameter) {
  return axios({
    url: url,
    method: "post",
    data: parameter,
    // dataType:'json'
  });
}


